import { WebPNextImage } from '@/components/WebPImage';
import { Tooltip } from 'antd';
import Image from 'next/image';
const Info = '/img/products/vod-assessment/info.webp';
interface IProps {
  title: string;
  width?: number;
  height?: number;
  style?: any;
}

const InfoTooltip = ({
  title,
  width = 14,
  height = 14,
  style,
  ...props
}: IProps) => {
  const defaultStyle = {
    padding: '0 5px',
    verticalAlign: 'middle',
    cursor: 'pointer',
  };
  const Style = Object.assign({}, defaultStyle, style);
  return (
    <span style={Style}>
      <Tooltip title={title}>
        <WebPNextImage
          src={Info}
          alt="info"
          height={width}
          width={height}
          crossOrigin="anonymous"
          {...props}
        />
      </Tooltip>
    </span>
  );
};

export default InfoTooltip;
